module.exports = __webpack_public_path__ + "img/mt4_bg2.c84c3a63.png";